module.exports = __webpack_public_path__ + "media/bom/Data-Sheet-Icon-Off-bfc30807.svg";